import React from "react";
import { motion } from "framer-motion";
import {
  FaEdit,
  FaTrash,
  FaInfoCircle,
  FaUser,
  FaClock,
  FaSignal,
  FaEnvelope,
  FaMapMarkerAlt,
  FaTrophy
} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import * as FaIcons from "react-icons/fa";

const isImageIcon = (icon) => {
  if (!icon) return false;
  console.log("iconicon", icon);
  return (
    icon.startsWith("http") ||icon.startsWith("https") ||
    icon.startsWith("/") ||
    icon.match(/\.(png|jpg|jpeg|svg|webp)$/i)
  );
};

const getIconComponent = (icon) => {
  if (!icon) return null;
  return FaIcons[icon] || null;
};


const CourseCard = ({
  course, 
  onView,
  onEdit,
  onDelete,
  isProfessorView = false,
}) => {
  console.log("coursecourse", course);
  
  // Handle default values and instructor info
  const courseData = {
    title: course.name || "Sans titre",
    description: course.description || "Aucune description",
    price: course.price ? `${course.price} D.A` : "Gratuit",
    duration: course.duree || "Non spécifiée",
    level: course.niveau || "Tous niveaux",
    instructor: {
      name: course.instructor_name || "Non spécifiée",
      email: course.instructor_email || "Email non disponible",
      phone: course.instructor_phone || "Non spécifié",
      wilaya: course.instructor_wilaya || "Non spécifiée",
      bio: course.instructor_bio || "Non spécifiée",
      achievements:
        course.instructor_achievements &&
        Array.isArray(course.instructor_achievements)
          ? course.instructor_achievements
          : course.instructor_achievements
          ? [course.instructor_achievements]
          : ["Non spécifiée"],
    },
  };

  // Level configuration
  const getLevelConfig = (level) => {
    const levels = {
      "Débutant": {
        bg: "bg-gradient-to-r from-blue-500/20 to-cyan-500/20",
        color: "from-blue-500 to-cyan-500",
        badge: "bg-blue-50 text-blue-600",
        icon: <FaSignal className="text-xs" />
      },
      "Intermédiaire": {
        bg: "bg-gradient-to-r from-emerald-500/20 to-green-500/20",
        color: "from-emerald-500 to-green-500",
        badge: "bg-emerald-50 text-emerald-600",
        icon: <FaSignal className="text-xs" />
      },
      "Avancé": {
        bg: "bg-gradient-to-r from-purple-500/20 to-pink-500/20",
        color: "from-purple-500 to-pink-500",
        badge: "bg-purple-50 text-purple-600",
        icon: <FaSignal className="text-xs" />
      },
      "Expert": {
        bg: "bg-gradient-to-r from-amber-500/20 to-orange-500/20",
        color: "from-amber-500 to-orange-500",
        badge: "bg-amber-50 text-amber-600",
        icon: <FaSignal className="text-xs" />
      }
    };
    
    return levels[level] || {
      bg: "bg-gradient-to-r from-gray-500/20 to-gray-600/20",
      color: "from-gray-500 to-gray-600",
      badge: "bg-gray-50 text-gray-600",
      icon: <FaSignal className="text-xs" />
    };
  };

  const levelConfig = getLevelConfig(courseData.level);

  return (
    <motion.div
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true }}
      transition={{ 
        type: "spring",
        stiffness: 100,
        damping: 15
      }}
      whileHover={{ 
        y: -12,
        transition: { type: "spring", stiffness: 300 }
      }}
      className="group relative h-full flex"
    >
      {/* Card container with gradient border */}
      <div className={`relative flex flex-col h-full w-full rounded-2xl ${levelConfig.bg} p-0.5`}>
        <div className="relative flex flex-col h-full bg-white rounded-[1.2rem] overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
          {/* Corner accent */}
          <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl ${levelConfig.color} opacity-10 rounded-bl-full`} />

          {/* Header with level indicator */}
          <div className="relative px-5 pt-5">
            <div className="flex items-start justify-between mb-4">
              <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full ${levelConfig.badge} backdrop-blur-sm border border-white/50`}>
                {levelConfig.icon}
                <span className="text-xs font-semibold">{courseData.level}</span>
              </div>
              
              {/* Action buttons for professor */}
              {isProfessorView && (
                <div className="flex items-center gap-2">
                  <motion.button
                    whileTap={{ scale: 0.9 }}
                    onClick={onEdit}
                    className={`w-8 h-8 rounded-lg flex items-center justify-center backdrop-blur-sm bg-white/80 border border-gray-100`}
                  >
                    <FaEdit className={`text-sm text-blue-500`} />
                  </motion.button>
                  
                  <motion.button
                    whileTap={{ scale: 0.9 }}
                    onClick={onDelete}
                    className={`w-8 h-8 rounded-lg flex items-center justify-center backdrop-blur-sm bg-white/80 border border-gray-100`}
                  >
                    <FaTrash className={`text-sm text-red-500`} />
                  </motion.button>
                </div>
              )}
            </div>

     
             {/* Course icon (image OR react-icon, never both) */}
<motion.div 
  whileHover={{ scale: 1.05 }}
  className={`relative w-14 h-14 rounded-xl mb-4 overflow-hidden bg-gradient-to-br ${levelConfig.color} p-0.5 flex items-center justify-center`}
>
  <div className="w-full h-full bg-white rounded-xl flex items-center justify-center overflow-hidden">
    
    {/* IMAGE ICON */}
    {isImageIcon(course.icon) && (
      <img
        src={course.icon.startsWith("http"||"https") ? course.icon : `${process.env.REACT_APP_LOCAL_API_URL}${course.icon}`}
        alt="course icon"
        className="w-8 h-8 object-contain"
      />
    )}

    {/* REACT ICON */}
    {!isImageIcon(course.icon) && getIconComponent(course.icon) && (
      <div
        className={`text-2xl bg-gradient-to-br ${levelConfig.color} bg-clip-text`}
      >
        {React.createElement(getIconComponent(course.icon))}
      </div>
    )}

    {/* FALLBACK */}
    {!course.icon && (
      <div
        className={`text-xl font-bold bg-gradient-to-br ${levelConfig.color} bg-clip-text`}
      >
        {courseData.title.charAt(0)}
      </div>
    )}

  </div>
</motion.div>


            {/* Course title with gradient */}
            <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight line-clamp-2">
              {courseData.title}
            </h3>

            {/* Course description */}
            <p className="text-sm text-gray-600 mb-4 leading-relaxed line-clamp-2">
              {courseData.description}
            </p>
          </div>

          {/* Flexible spacer */}
          <div className="flex-grow"></div>
          {/* Footer with buttons */}
          <div className="px-5 pb-4 pt-3 border-t border-gray-100 bg-white">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
<div className="text-right">
                <p className="text-lg font-bold text-blue-600">{courseData.price}</p>
              </div>
              {/* Action buttons */}
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }} 
                  onClick={onView}
                  className="px-4 py-2.5 rounded-lg border border-gray-200 text-xs font-semibold text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-all flex items-center justify-center gap-1.5 w-full sm:w-auto"
                >
                  <FaInfoCircle className="text-sm" />
                  Voir détails
                  <FontAwesomeIcon icon={faArrowRight} className="text-[10px]" />
                </motion.button>
                
                {!isProfessorView && (
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={onEdit}
                    className="px-4 py-2.5 rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-semibold hover:shadow-lg transition-all shadow-sm hover:shadow-blue-200 flex items-center justify-center gap-1.5 w-full sm:w-auto"
                  >
                    <FaEdit className="text-sm" />
                    Modifier
                    <FontAwesomeIcon icon={faArrowRight} className="text-[10px]" />
                  </motion.button>
                )}
              </div>
            </div>
          </div>

          {/* Hover shine effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 pointer-events-none" />
        </div>
      </div>
    </motion.div>
  );
};

export default CourseCard;